import { colors } from "../../Styles";

export function ArrowSmall({rotate = 0, transparency = 1, size = "20px", fillColor = colors.greyLightTertiary, transition = 0}) {
  return (
    <svg style={{transform: `rotate(${rotate}deg)`, transition: `${transition}s ease-in-out`}} opacity={transparency} rotate={rotate} height={size} width={size} fill={fillColor} version="1.1" viewBox="0 0 283.46 283.46">  
        <g transform="matrix(2.02224,0,0,2.02224,-296.842,-130.928)">
          <path d="M235.834,134.83L158.85,67.82L158.85,201.84L235.834,134.83Z"/>
        </g>
    </svg>
  );
}